import { Route, Routes } from 'react-router';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import {
  confirmSignupRoute,
  forgottenPasswordRoute,
  loginPageRoute,
  menuEditorRoute,
  resetPasswordRoute,
  signUpSuccessRoute,
  selfSignupRoute,
  subscriptionPageRoute,
  paymentSettingsRoute,
  settingsPageRoute,
  userManagementRoute,
  newRestaurantRoute,
  termsAndConditionsRoute,
  privacyPolicyRoute,
  statisticsRoute,
  mozrestRoute,
} from './config/pageRoutes';
import LoginPage from './pages/LoginPage';
import { AuthProvider } from './contexts/AuthContext';
import { UserProvider } from './contexts/UserContext';
import { SnackbarProvider } from './contexts/SnackbarContext';
import LocalizationHandler from './localization/LocalizationHandler';
import './i18n';
import ConfirmSignupPage from './pages/ConfirmSignupPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ForgottenPasswordPage from './pages/ForgottenPasswordPage';
import SignupSuccessPage from './pages/SignupSuccessPage';
import MenuEditorPage from './pages/MenuEditorPage';
import WelcomePage from './pages/WelcomePage';
import SelfSignupPage from './pages/SelfSignupPage';
import SubscriptionPage from './pages/SubscriptionPage';
import PaymentSettingsPage from './pages/PaymentSettingsPage';
import HeaderLayout from './layout/HeaderLayout';
import SettingsPage from './pages/SettingsPage';
import UsersPage from './pages/UsersPage';
import NewRestaurantPage from './pages/NewRestaurantPage';
import TermsAndConditionsPage from './pages/TermsAndConditionsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import StatisticsPage from './pages/StatisticsPage';
import MozrestPage from './pages/MozrestPage';

const darkTheme = createTheme({
  palette: {
    mode: 'light',
  },
  typography: {
    fontFamily: 'Inter, sans-serif',
  }
});

function App() {
  return (
    <div>
      <ThemeProvider theme={darkTheme}>
        <SnackbarProvider>
          <AuthProvider>
            <Routes>
              <Route element={<LocalizationHandler />}>
                <Route element={<UserProvider />}>
                  <Route element={<HeaderLayout />}>
                    <Route path={"/"} element={<WelcomePage />} />
                    <Route path={menuEditorRoute.path} element={<MenuEditorPage />} />
                    <Route path={settingsPageRoute.path} element={<SettingsPage />} />
                    <Route path={subscriptionPageRoute.path} element={<SubscriptionPage />} />
                    <Route path={paymentSettingsRoute.path} element={<PaymentSettingsPage />} />
                    <Route path={userManagementRoute.path} element={<UsersPage />} />
                    <Route path={newRestaurantRoute.path} element={<NewRestaurantPage />} />
                    <Route path={statisticsRoute.path} element={<StatisticsPage />} />
                    <Route path={mozrestRoute.path} element={<MozrestPage />} />
                  </Route>
                </Route>
                <Route path={loginPageRoute.path} element={<LoginPage />} />
                <Route path={confirmSignupRoute.path} element={<ConfirmSignupPage />} />
                <Route path={resetPasswordRoute.path} element={<ResetPasswordPage />} />
                <Route path={forgottenPasswordRoute.path} element={<ForgottenPasswordPage />} />
                <Route path={signUpSuccessRoute.path} element={<SignupSuccessPage />} />
                <Route path={selfSignupRoute.path} element={<SelfSignupPage />} />
                <Route path={termsAndConditionsRoute.path} element={<TermsAndConditionsPage />} />
                <Route path={privacyPolicyRoute.path} element={<PrivacyPolicyPage />} />
              </Route>
            </Routes>
          </AuthProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
